export const clearStore = "USER_SETTING_CLEAR_STORE";

export const listLoadStart = "USER_SETTING_LIST_LOAD_START";
export const listLoadSuccess = "USER_SETTING_LIST_LOAD_SUCCESS";
export const listLoadFail = "USER_SETTING_LIST_LOAD_FAIL";

export const itemSaveStart = "USER_SETTING_ITEM_SAVE_START";
export const itemSaveSuccess = "USER_SETTING_ITEM_SAVE_SUCCESS";
export const itemSaveFail = "USER_SETTING_ITEM_SAVE_FAIL";
